<template>
  <v-container>
    <parent-dialog-popup
      :dialog="value"
      @dialogItem="moveCheckpoint($event)"
      @item-selected="handleItemSelected"
      @add-item-selected="addHandleItemSelected"
      @back="emit('input', false)"
      :label="OrgObjectType"
      :objectType="extractedWords.join(' ')"
      :parentName="parentName"
      :items="items"
      :existingNamesList="existingNamesList"
      :buttonLabel="buttonLabel"
      buttonLabel="Move"
      modalType="Move"
      :openDefault="true"
      type="move_checkpoint"
      :maxWidth="'612'"
    />
  </v-container>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import ParentDialogPopup from '@components/ParentModal/ParentDialogPopup.vue';

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  OrgObjectType: {
    type: String,
    default: 'Responsibility to Role',
  },
  parentName: {
    type: String,
    default: 'Team Leader',
  },
  items: {
    type: Array,
    default: () => [],
  },
  existingNamesList: {
    type: Array,
    default: () => [],
  },
  buttonLabel: {
    type: String
  }
});

const emit = defineEmits(['input', 'onSave', 'item-selected', 'add-item-selected']);

const extractedWords = ref([]);

const extractedOrgObjectType = computed(() => {
  if (props.OrgObjectType) {
    const index = props.OrgObjectType.indexOf(' to ');
    if (index !== -1) {
      return props.OrgObjectType.substring(0, index);
    }
  }
  return '';
});

watch(() => props.OrgObjectType, (newValue) => {
  extractedWords.value = extractedOrgObjectType.value.split(' ');
});

onMounted(() => {
  if (props.OrgObjectType) {
    extractedWords.value = extractedOrgObjectType.value.split(' ');
  }
});

const moveCheckpoint = (role) => {
  emit("onSave", role);
};

const handleItemSelected = (data) => {
  emit("item-selected", data);
};

const addHandleItemSelected = (data) => {
  emit("add-item-selected", data);
};
</script>
<style>
  .custom-list {
    margin-top: -10px;
    width: 564px;
  }
  .v-text-field__slot {
    height: auto;
  }
</style>